import { ResolveFn } from '@angular/router';
import {HeroReport} from "./hero-report.model";
import {HeroReportService} from "./hero-report.service";
import {inject} from "@angular/core";

export const heroReportByIdResolver: ResolveFn<HeroReport> = (route, state) => {
  const heroReportService: HeroReportService = inject(HeroReportService)
  return heroReportService.fetchById(route.params['id'])
};
